export default "__VITE_ASSET__DtAfYTqg__"